import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { PaymentAllocation } from 'src/features/paymentAllocations/utils/types';
import DeletePaymentAllocationFormModal from 'src/features/paymentAllocations/components/forms/DeletePaymentAllocationFormModal';

export default function CellPaymentAllocationActions({ row }: CellContext<PaymentAllocation, unknown>) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <DeletePaymentAllocationFormModal selectedPaymentAllocation={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeletePaymentAllocationFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
